//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { FamilyAccountBalanceReportSortBy, ReportType } from './Enums';

export class FamilyAccountBalanceReportInputItem extends ReportInputItem {
    BalanceDate: string = "1970-01-01T00:00:00";
    IncludeInactiveFamilies: boolean = false;
    SortBy: FamilyAccountBalanceReportSortBy = FamilyAccountBalanceReportSortBy.Balance;
    override readonly Type: ReportType = ReportType.FamilyAccountBalance;

    constructor(initializer?: Partial<Omit<FamilyAccountBalanceReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "FamilyAccountBalanceReportInputItem";
}
